import React, { useState } from 'react';
import { DualAxes, Tiny } from '@ant-design/plots';
import { Pie } from '@ant-design/plots';
import PageTitle from '../../Ui/PageTitle';
import PatientBookingPolarChart from '../../Charts/PatientBookingPolarChart';
import BookingBarChart from '../../Charts/CompletedBookingChart';
import { useInsights } from '../../../hooks/useInsights';

const Insights = ({ baseUrl }) => {
    const [revenueData, setrevenueData] = useState([264, 417, 438, 887, 309, 397, 550, 575, 563, 430, 525, 592, 492, 467, 513, 546, 983, 340, 539, 243, 226, 192]);
    const [totalrevenue, settotalrevenue] = useState(2000);
    const [ProfitData, setProfitData] = useState([264, 417, 180, 226, 309, 397, 550, 575, 690, 430, 525, 592, 492, 467, 804, 546, 983, 340, 539, 887, 226, 192]);
    const [totalProfit, settotalProfit] = useState(200);
    const { data, isLoading } = useInsights();


    const headers = { 'Authorization': 'Bearer ' + localStorage.getItem('adminToken') };


    const pieConfig = {
        data: [
            { type: 'Pending', Bookings: data?.bookingStatusCounts.Pending || 0 },
            { type: 'Completed', Bookings: data?.bookingStatusCounts.Completed || 0 },
            { type: 'Canceled', Bookings: data?.bookingStatusCounts.Cancelled || 0 }, // Fixed typo: 'Canceld' to 'Canceled'
            { type: 'Skipped', Bookings: data?.bookingStatusCounts.Skiped || 0 }, // Fixed typo: 'Canceld' to 'Canceled'
        ],
        angleField: 'Bookings',
        colorField: 'type',
        radius: 0.8, // Slightly increased for better visibility
        innerRadius: 0.5, // Kept for donut-style chart
        color: ['#F7C137', '#FFA500', '#F44336', '#4CAF50'], // yellow, orange, red, green
        label: {
            text: 'Bookings',
            content: ({ percent }) => `${(percent * 100).toFixed(0)}%`, // Show percentage
            style: {
                fontSize: 14,
                fontWeight: 'bold',
                textAlign: 'center',
                fill: '#fff', // White text for contrast against colors
            },
        },
        statistic: {
            title: {
                content: 'Bookings', // Title in the center
                style: {
                    fontSize: '16px',
                    fontFamily: 'Poppins',
                    color: '#4B5EAA', // Subtle color for title
                },
            },
            content: {
                content: '', // Remove default content to avoid clutter
            },
        },

        tooltip: (datum) => ({
            name: datum.type,
            value: `${datum.Bookings} Bookings (${(datum.Bookings / 17 * 100).toFixed(1)}%)`, // Custom tooltip
        })
        ,
        animation: {
            appear: {
                animation: 'fade-in', // Smooth fade-in animation
                duration: 800,
            },
        },
        legend: {
            position: 'bottom', // Move legend to bottom for better layout
            layout: 'horizontal',
            itemName: {
                style: {
                    fontFamily: 'Poppins',
                    fontSize: 12,
                },
            },
        },
    };



    const data2 = [
        { mon: 'jan', last: 3, current: 10 },
        { mon: 'feb', last: 4, current: 4 },
        { mon: 'mar', last: 3.5, current: 5 },
        { mon: 'apr', last: 3, current: 4 },
        { mon: 'may', last: 6, current: 7 },
        { mon: 'jun', last: 9, current: 6 },
        { mon: 'jul', last: 4, current: 4.9 },
        { mon: 'aug', last: 4.9, current: 4 },
        { mon: 'sep', last: 6, current: 35 },
        { mon: 'oct', last: 15, current: 35 },
        { mon: 'nov', last: 7, current: 7 },
        { mon: 'dec', last: 9, current: 1 },
    ];

    const config5 = {
        data: data2,
        xField: 'mon',
        legend: true,
        children: [
            {
                type: 'line',
                yField: 'last',
                shapeField: 'smooth',
                style: {
                    stroke: 'red',
                    lineWidth: 4,
                    opacity: 0.5,
                },
                axis: {
                    y: {
                        title: 'last year',
                        style: { titleFill: 'gray' },
                        position: 'right',
                    },
                },
            },
            {
                type: 'line',
                yField: 'current',
                shapeField: 'smooth',
                style: {
                    lineWidth: 3,
                    stroke: '#2487EA',
                },
            },
        ],
        axis: {
            y: {
                position: 'left',
                title: 'current year',
                style: { titleFill: 'gray' },
            },
        },
        height: 400,
    };

    return (
        <div className="w-xl px-4 sm:px-6 lg:px-8 md:w-2xl mx-auto">
            <div className="animate-fade-in ">
                {/* <PageTitle
                    title="Insights & Analytics"
                    subtitle="A deep dive into your clinic's performance metrics"
                /> */}
                <h1 className='font-bold md:text-3xl'>Insights & Analytics</h1>
                <p className='text-xs md:text-xl text-gray-500'>A deep dive into your clinic's performance metrics</p>
  <BookingBarChart/>




                {/* <section className="bg-primary/20 rounded-lg shadow-sm py-4 px-6">
                    <h5 className="font-montserrat font-bold text-lg sm:text-xl">Monthly Booking Income Comparison</h5>
                    <div className="flex justify-center items-center gap-6 mb-4">
                        <div className="flex items-center gap-2">
                            <div className="bg-blue-600 rounded-full w-3 h-3"></div>
                            <p className="m-0 font-montserrat text-sm sm:text-base">Current income</p>
                        </div>
                        <div className="flex i  tems-center gap-2">
                            <div className="bg-red-600 rounded-full w-3 h-3"></div>
                            <p className="m-0 font-montserrat text-sm sm:text-base">Last income</p>
                        </div>
                    </div>
                    <DualAxes {...config5} />

                </section> */}
                <div className="bg-gray-100  flex flex-col md:flex-row justify-between   md:w-full  shadow-lg rounded-b-2xl p-5">
                    <PatientBookingPolarChart />
                    <div className=" border-0 rounded-lg shadow-sm px-4 pt-4 self-center w-[100%] md:w-[40%]">
                        <div className="flex justify-between items-center ">
                            <h5 className="font-montserrat font-bold text-lg sm:text-xl">Booking Status</h5>
                        </div>
                        <Pie {...pieConfig} />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Insights;
